import { Injectable } from '@angular/core';

import { HttpClientService } from '../common/http-client.service';

@Injectable()
export class SettingService {
  private settingsURL = 'settings';

  constructor(private httpClient: HttpClientService) {}

  getSettings(data: any): Promise<any> {
    return this.httpClient.get(`${this.settingsURL}.json`, data).catch(function () {});
  }

  createSetting(data: any): Promise<any> {
    return this.httpClient.post(`${this.settingsURL}.json`, data).catch(function () {});
  }

  updateSetting(settingId: number, data: any): Promise<any> {
    return this.httpClient.put(`${this.settingsURL}/${settingId}.json`, data).catch(function () {});
  }

  getSetting(settingId: number): Promise<any> {
    return this.httpClient.get(`${this.settingsURL}/${settingId}.json`).catch(function () {});
  }

  deleteSetting(settingId: number): Promise<any> {
    return this.httpClient.delete(`${this.settingsURL}/${settingId}.json`).catch(function () {});
  }
}
